module.exports = __webpack_public_path__ + "static/img/504.57e843f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/504.png
// module id = 533
// module chunks = 3